import React from 'react';

export interface Props {
  message?: string,
  onNext: (arg?: any) => void,
}

export default function Success({ message }: Props) {
  return (
    <div>
      <h1 className="heading heading--3">Success!</h1>
      <p dangerouslySetInnerHTML={{ __html: message ?? '' }} />
    </div>
  );
}

Success.displayName = 'Success';
